module.exports = __webpack_public_path__ + "img/modal-medical-form.4d5ccaf3.svg";